'use strict';

var DemandTransparencyPanelDirective = function DemandTransparencyPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-transparency-panel.html'),
    controller: 'DemandTransparencyPanelController',
    scope: {
      contextData: '=',
      dataDimension: '=dimension'
    }
  };
};
DemandTransparencyPanelDirective.$inject = [];
module.exports = DemandTransparencyPanelDirective;